/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Plan_Discount_Form_Expires_At_OverrideInputs */

const en_admin_plan_discount_form_expires_at_override = /** @type {(inputs: Admin_Plan_Discount_Form_Expires_At_OverrideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expires at`)
};

const de_admin_plan_discount_form_expires_at_override = /** @type {(inputs: Admin_Plan_Discount_Form_Expires_At_OverrideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ablaufdatum`)
};

const es_admin_plan_discount_form_expires_at_override = /** @type {(inputs: Admin_Plan_Discount_Form_Expires_At_OverrideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de vencimiento`)
};

const fr_admin_plan_discount_form_expires_at_override = /** @type {(inputs: Admin_Plan_Discount_Form_Expires_At_OverrideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date d'expiration`)
};

const it_admin_plan_discount_form_expires_at_override = /** @type {(inputs: Admin_Plan_Discount_Form_Expires_At_OverrideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scade il`)
};

const pt_br2_admin_plan_discount_form_expires_at_override = /** @type {(inputs: Admin_Plan_Discount_Form_Expires_At_OverrideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expira em`)
};

const pl_admin_plan_discount_form_expires_at_override = /** @type {(inputs: Admin_Plan_Discount_Form_Expires_At_OverrideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wygasa`)
};

const hu_admin_plan_discount_form_expires_at_override = /** @type {(inputs: Admin_Plan_Discount_Form_Expires_At_OverrideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lejár`)
};

const ro_admin_plan_discount_form_expires_at_override = /** @type {(inputs: Admin_Plan_Discount_Form_Expires_At_OverrideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Expira la`)
};

/**
* | output |
* | --- |
* | "Expires at" |
*
* @param {Admin_Plan_Discount_Form_Expires_At_OverrideInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_plan_discount_form_expires_at_override = /** @type {((inputs?: Admin_Plan_Discount_Form_Expires_At_OverrideInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Plan_Discount_Form_Expires_At_OverrideInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_plan_discount_form_expires_at_override(inputs)
	if (locale === "de") return de_admin_plan_discount_form_expires_at_override(inputs)
	if (locale === "es") return es_admin_plan_discount_form_expires_at_override(inputs)
	if (locale === "fr") return fr_admin_plan_discount_form_expires_at_override(inputs)
	if (locale === "it") return it_admin_plan_discount_form_expires_at_override(inputs)
	if (locale === "pt-BR") return pt_br2_admin_plan_discount_form_expires_at_override(inputs)
	if (locale === "pl") return pl_admin_plan_discount_form_expires_at_override(inputs)
	if (locale === "hu") return hu_admin_plan_discount_form_expires_at_override(inputs)
	return ro_admin_plan_discount_form_expires_at_override(inputs)
});
export { admin_plan_discount_form_expires_at_override as "admin.plan_discount_form.expires_at_override" }